import { Account, fetchAccounts } from 'pages/ManageAccounts'
import { ReactNode, useCallback, useState } from 'react'
import DebounceSelect from './AntDebouncedSelect'

const createOption = (v: Account) => {
    let label = v.username
    if (v.firstName && v.lastName) {
        label += ` - ${v.firstName} ${v.lastName}`
    }
    return { label, value: JSON.stringify(v) }
}

const _fetchAccounts = async (prefix) => {
    let values = await fetchAccounts({
        [`filters[$or][0][firstName][$containsi]`]: prefix,
        [`filters[$or][1][lastName][$containsi]`]: prefix,
        [`filters[$or][2][email][$containsi]`]: prefix,
    })
    return values.map(o => createOption(o))
}

export default function useNames(): [Account | null, () => ReactNode] {
    const [user, setUser] = useState()

    let renderer: () => ReactNode = useCallback(
        () => {
            return <div style={{ width: 500 }}>
                <DebounceSelect
                    showSearch
                    allowClear
                    value={user ? createOption(user) : null}
                    placeholder="Student"
                    fetchOptions={(prefix) => _fetchAccounts(prefix)}
                    onChange={(newValue) => {
                        console.log(newValue)
                        //@ts-ignore
                        setUser(newValue ? JSON.parse(newValue) : null)
                    }}
                    style={{ width: '100%' }}
                />
            </div>
        },
        [user, setUser],
    )

    return [user || null, renderer]
}